import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Input, SelectPicker, Tag, TagPicker } from "rsuite";
import Pagination from "rsuite/Pagination";
import Swal from "sweetalert2";
import { APi } from "../../../Api/";
import { exportAddAtom } from "../../../Atoms/exportAdd.atom";
import ExportAdd from "../../../Components/Common/ExportAdd";
import Filter from "../../../Components/Common/Filter";
import Grid from "../../../Components/Grid";
import Responsive from "../../../Components/Responsive";
import { serviceTypes } from "../../../Constants/types";
import validate from "../../../Helpers/validate";
import { ProviderModel, Tier } from "../../../Models/TiersModels";
import AddEdit from "./AddEdit.component";
import { multiDataSet } from "./excel_data";
export default function Provider(props) {
  // STATE
  const [data, setdata] = useState(fakeData);
  const [totalCount, settotalCount] = useState(0);
  const [filterModel, setfilterModel] = useState({
    q: "",
    page: 1,
    take: 20,
    serviceType: 0,
  });
  // --- add edit model ---
  const [error, setError] = useState("");
  const [model, setmodel] = useState(new ProviderModel());

  // ATOMS
  const [state, setstate] = useRecoilState(exportAddAtom);
  // HELPERS
  const reset = () => {
    setmodel(new ProviderModel());
    setError("");
  };
  // API CALLS

  const fetch = () => {
    setstate((prev) => {
      return { ...prev, loading: true };
    });
    APi.createAPIEndpoint(APi.ENDPOINTS.Provider, filterModel)
      .fetchAll()
      .then((res) => {
        setdata(res.data.data);
        setstate((prev) => {
          return { ...prev, loading: false };
        });
        settotalCount(res.data.totalCount);
      })
      .catch((e) => {
        setError(e.Message);
        setstate((prev) => {
          return { ...prev, loading: false };
        });
      });
  };
  const save = () => {
    let msg = validate(model, [{ name: "Nom" }]);
    if (msg) setError(msg);
    else {
      setstate((prev) => {
        return { ...prev, loading: true };
      });
      if (model.id) {
        APi.createAPIEndpoint(APi.ENDPOINTS.Provider)
          .update(model.id, {
            ...model,
          })
          .then((res) => {
            fetch();
            setstate((prev) => {
              return { ...prev, open: false, loading: false };
            });
            reset();
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Élément a été bien modifié !",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((e) => {
            setError(e.Message);
            setstate((prev) => {
              return { ...prev, loading: false };
            });
          });
      } else {
        APi.createAPIEndpoint(APi.ENDPOINTS.Provider)
          .create({
            ...model,
            // serviceTypes: model.serviceTypes ? model.serviceTypes.join() : "",
          })
          .then((res) => {
            fetch();
            reset();
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Element a été bien ajouté !",
              showConfirmButton: false,
              timer: 1500,
            });
            setstate((prev) => {
              return { ...prev, open: false, loading: false };
            });
          })
          .catch((e) => {
            setError(e.Message);
            setstate((prev) => {
              return { ...prev, loading: false };
            });
          });
      }
    }
  };
  const deleteAction = (id) => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Provider)
      .delete(id)

      .then((res) => {
        fetch();
        Swal.fire("Supprimé !", "", "success");
      })
      .catch((e) => setError(e.Message));
  };
  const getBYId = (id) => {
    setError("");
    setmodel(data.find((el) => el.id == id));
  };
  // LIFE CYCLES
  useEffect(() => {
    fetch();
  }, [filterModel.page, filterModel.take]);
  return (
    <div>
      <Filter search={() => fetch()}>
        <Responsive m={6} l={6} xl={6} className="p-10">
          <label>Nom: </label>

          <Input
            placeholder="recherche"
            onChange={(q) => {
              setfilterModel((prev) => {
                return { ...prev, q };
              });
            }}
          />
        </Responsive>
        <Responsive m={6} l={6} xl={6} className="p-10">
          <label>Services Fournies :</label>
          <SelectPicker
            searchable={false}
            data={[{ label: "Tout", value: 0 }].concat(serviceTypes)}
            block
            noSearch
            value={filterModel.serviceType}
            onSelect={(serviceType) => {
              setfilterModel((prev) => {
                return { ...prev, serviceType };
              });
            }}
          />
        </Responsive>
      </Filter>
      <ExportAdd
        ActionOnClose={reset}
        size="md"
        excelData={multiDataSet(data)}
        save={save}
        AddComponent={
          <AddEdit
            error={error}
            model={model}
            _setmodel={setmodel}
            serviceTypes={serviceTypes}
          />
        }
      />{" "}
      <Grid
        editAction={(id) => {
          getBYId(id);

          setstate((prev) => {
            return { ...prev, open: true };
          });
        }}
        deleteAction={deleteAction}
        actionKey="id"
        noAdvancedActions // for custom advanced actions
        columns={columns}
        rows={data}
      />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[10, 20, 50, 100]}
          limit={filterModel.take}
          activePage={filterModel.page}
          onChangePage={(page) => {
            window.scrollTo(0, 0);
            setfilterModel((prev) => {
              return { ...prev, page };
            });
          }}
          onChangeLimit={(take) => {
            console.log(take);
            setfilterModel((prev) => {
              return { ...prev, take, page: 1 };
            });
          }}
        />
      </div>
    </div>
  );
}

const columns = [
  {
    value: "name",
    name: "Nom",
    render: (v) => <a>{v}</a>,
  },

  {
    value: "code",
    name: "Code",
    render: (v) => <b>{v}</b>,
  },

  {
    value: "taxCode",
    name: "Code Tax",
    render: (v) => <b style={{ color: "green" }}>{v}</b>,
  },
  {
    value: "address",
    name: "Adresse",
    render: (v) => <i style={{ color: "#232323" }}>{v}</i>,
  },
  {
    value: "emails",
    name: "Emails",
    render: (v) => {
      return (
        <div style={{ maxWidth: "260px", overflow: "auto" }}>
          {v &&
            v.split(",").map((k, i) => (
              <a
                href={"mailto:" + k}
                style={{
                  display: "inline-block",
                  margin: "5px",
                  border: "1px solid rgba(93,120,255,0.2)",
                  borderRadius: "3px",
                  padding: "3px 4px",
                }}
              >
                {k}
              </a>
            ))}
        </div>
      );
    },
  },

  {
    value: "phones",
    name: "Numéros de téléphones",
    render: (v) => {
      return (
        <div style={{ maxWidth: "260px", overflow: "auto" }}>
          {v &&
            v.split(",").map((k, i) => (
              <a
                href={"tel:" + k}
                style={{
                  color: "rgba(11,150,102,1)",
                  display: "inline-block",
                  margin: "5px",
                  border: "1px solid rgba(11,150,102,0.2)",
                  borderRadius: "3px",
                  padding: "3px 4px",
                }}
              >
                {k}
              </a>
            ))}
        </div>
      );
    },
  },
  {
    value: "serviceTypes",
    name: "Services Fournies",
    render: (v) => {
      return (
        <div style={{ maxWidth: "260px", overflow: "auto" }}>
          {v &&
            serviceTypes
              .filter((el) => v.includes(el.value))
              .map((k, i) => <Tag color="violet">{k.label}</Tag>)}
        </div>
      );
    },
  },
];

const fakeData = [
  {
    id: 1,
    code: "TND",
    name: "Dinar",
  },
];
